<!--suppress ALL -->
<template>
  <div class="card-item card" :class="className">
    <header v-if="$scopedSlots.header || $slots.header" class="card-header">
      <slot name="header"></slot>
    </header>
    <header v-else-if="header && header.title" class="card-header">
      <p class="card-header-title">
        {{ header.title }}
      </p>
      <a v-if="header.icon" @click="$emit('header-click')"
         class="card-header-icon">
              <span class="icon">
                <i :class="header.icon" aria-hidden="true"></i>
              </span>
      </a>
    </header>
    <slot name="custom-section"></slot>
    <div v-if="$scopedSlots.image || $slots.image" class="card-image">
      <slot name="image"></slot>
    </div>
    <div v-if="$scopedSlots.default || $slots.default" class="card-content"
         :class="($scopedSlots.footer || $slots.footer) ? 'skip-rounded' : ''">
      <slot></slot>
    </div>
    <div v-if="$scopedSlots.footer || $slots.footer" class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'annotation';

@Component
export default class CardItem extends Vue {

  @Prop({default: {}})
  public header: any;

  @Prop({default: '', type: String})
  public type: string;

  @Prop({default: false, type: Boolean})
  public rounded: boolean;

  public get className() {
    return [this.type ? ('is-' + this.type) : '', {'rounded': this.rounded}];
  }
}
</script>

<style lang="scss">
@import "../../style/variables_function";

@each $name, $pair in $colors_type {
  .card-item.is-#{$name} {
    $color: nth($pair, 1);
    $color-invert: nth($pair, 2);

    header {
      background-color: $color;
    }

    .card-header-title, .card-header-icon {
      color: $color-invert;
    }
  }
}

.card-item.is-primary-young {
  header {
    background-color: $color-primary-young;
  }

  .card-header-title, .card-header-icon {
    color: white;
  }
}

.card-item.rounded {
  border-radius: 5px;

  header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .card-content:not(.skip-rounded), .card-footer {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
